<template>
  <div class="main-container">
    <router-view></router-view>

    <!-- Navbar section -->
    <Header />

    <!-- hero section -->
    <Hero />

    <!-- service area  -->
    <CurveShape class="no-height">
      <template v-slot:bgcolor>
        <path
          style="fill: #ffffff; stroke-miterlimit: 10"
          d="M3360.5,97.739c-242,0-480-48.375-480-48.375
                        S2647.5,0.5,2400.5,0.5s-480,48.375-480,48.375s-238,48.864-480,48.864s-480-48.375-480-48.375S727.5,0.5,480.5,0.5
                        S0.5,48.875,0.5,48.875V108h1920h1920V48.875C3840.5,48.875,3602.5,97.739,3360.5,97.739z"
        />
      </template>
    </CurveShape>
    <div
      class="start-ups-feature startup-about-feature section-space--pt_120 section-space--pb_60"
      id="about"
    >
      <div class="container">
        <div class="section-title-wrapper text-center section-space--mb_60">
          <h3 class="section-title mb-30 wow move-up">
            Think of it, imagine it, and we will build it for you.
          </h3>
          <span class="section-text wow move-up">
            We’ve created software of all scales, from small to very large scale
            systems
          </span>
        </div>
        <ServicesSummary />
      </div>
    </div>

    <div class="start-ups-feature" id="platform">
      <div class="container">
        <div class="section-title text-center section-space--mb_60">
          <h3 class="font-weight--bold mb-15 wow move-up">
            All platforms, we are there...
          </h3>
        </div>
        <HPlatforms />
      </div>
    </div>

    <div
      class="tabs-wrapper startup-tab section-space--mt_30 section-space--pb_120"
    >
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div
              class="section-title-wrapper text-center section-space--mb_60 wow move-up"
            >
              <h2 class="section-title font-weight--bold mb-15">
                We design powerful systems to <br />
                complement your business.
              </h2>
            </div>
          </div>
        </div>
        <MissionAndValuesTab />
      </div>
    </div>

    <!--    &lt;!&ndash; team component &ndash;&gt;-->
    <!--    <div-->
    <!--      class="team-member-wrapper section-space&#45;&#45;ptb_120 default-bg"-->
    <!--      id="team"-->
    <!--    >-->
    <!--      <div class="container">-->
    <!--        <HTeam />-->
    <!--      </div>-->
    <!--    </div>-->

    <CarouselClients />

    <!-- contact form section -->
    <ContactForm />

    <FooterMain />
  </div>
</template>

<script>
import Header from "../components/HHeader";
import Hero from "../components/HHero";
import CurveShape from "../components/CurveShape";
import ServicesSummary from "../components/ServicesSummary";
import HPlatforms from "../components/HPlatforms";
import MissionAndValuesTab from "../components/MissionAndValuesTab";
import ContactForm from "../components/ContactForm";
import FooterMain from "../components/FooterMain";
import CarouselClients from "@/components/CarouselClients";

export default {
  name: "app",
  components: {
    CarouselClients,
    Header,
    Hero,
    CurveShape,
    ServicesSummary,
    HPlatforms,
    MissionAndValuesTab,
    ContactForm,
    FooterMain,
  },

  metaInfo: {
    title: "HobbsTech - Home",
    htmlAttrs: {
      lang: "en",
      amp: true,
    },
  },
};
</script>
